// API Configuration
const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8080/api';
const BACKEND_BASE_URL = process.env.REACT_APP_API_URL
  ? process.env.REACT_APP_API_URL.replace('/api', '')
  : 'http://localhost:8080';

export const API_ENDPOINTS = {
  AUTH: {
    SIGNIN: `${API_BASE_URL}/auth/signin`,
    SIGNUP: `${API_BASE_URL}/auth/signup`,
    GOOGLE_OAUTH: `${BACKEND_BASE_URL}/oauth2/authorization/google` // Direct to Spring Boot OAuth endpoint
  },
  CONTACT: {
    SUBMIT: `${API_BASE_URL}/contact`,
    ALL: `${API_BASE_URL}/contact/all`,
    MARK_PROCESSED: (id) => `${API_BASE_URL}/contact/${id}/process`
  },
  BOOKINGS: {
    CREATE: `${API_BASE_URL}/bookings`,
    USER_BOOKINGS: `${API_BASE_URL}/bookings/user`,
    GET_BY_ID: (id) => `${API_BASE_URL}/bookings/${id}`,
    CANCEL: (id) => `${API_BASE_URL}/bookings/${id}/cancel`,
    ALL: `${API_BASE_URL}/bookings`,
    UPDATE_STATUS: (id) => `${API_BASE_URL}/bookings/${id}/status`,
    DELETE: (id) => `${API_BASE_URL}/bookings/${id}`,
    BOOKED_SLOTS: (date) => `${API_BASE_URL}/bookings/booked-slots?date=${date}`
  },
  PAYMENT: {
    CREATE_ORDER: `${API_BASE_URL}/payment/create-order`,
    VERIFY: `${API_BASE_URL}/payment/verify`
  },
  SPECIAL_OFFER: {
    CREATE_ORDER: `${API_BASE_URL}/special-offer/create-order`,
    VERIFY: `${API_BASE_URL}/special-offer/verify`,
    ALL: `${API_BASE_URL}/special-offer/all`
  },
  HOROSCOPES: {
    BY_SIGN: (sign) => `${API_BASE_URL}/horoscopes/${sign}`,
    BY_SIGN_AND_PERIOD: (sign, period) => `${API_BASE_URL}/horoscopes/${sign}/${period}`,
    UPSERT: (sign, period) => `${API_BASE_URL}/horoscopes/${sign}/${period}`
  },
  ADMIN: {
    STATS: `${API_BASE_URL}/admin/stats`
  },
  TEST: {
    GET: `${API_BASE_URL}/test/get`,
    POST: `${API_BASE_URL}/test/post`
  }
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  INTERNAL_SERVER_ERROR: 500
};

export default API_BASE_URL;
